import type PrintContext from '../interfaces/PrintContext'

/** DM `appMessageForward` type for retail print jobs (local dev mirror). */
export const RETAIL_PRINT_JOB_DM_MESSAGE_TYPE = 'nxg.retail.print-job'

export type RetailPrintJobDmMessagePayload = {
  /** Compiled HTML sent to the printer. */
  html: string
  /** Liquid template source before compilation (for local re-compile in print-preview). */
  rawTemplate: string
  source: 'pos' | 'ssbt'
  data: PrintContext<unknown>
}

export const isDmAppMessageForwardEnabled = (): boolean =>
  import.meta.env.DEV === true && import.meta.env.VITE_DM_APP_MESSAGE_FORWARD === 'true'
